import { type EditorPlugin } from '../../types/aha-editor';
import { type Editor } from 'slate';
import { getParentList, spliceFragmentIntoList } from '../ListPlugin/utils';
import { decodeFragment } from '../../util/fragment';
import AhaEditor from '../../AhaEditor';
import TableUtils from '../TablePlugin/TableUtils';

const PasteFragmentIntoListPlugin: EditorPlugin = {
  name: 'Paste fragment into list plugin',
  insertData: (editor: Editor, data: DataTransfer) => {
    // Don't continue unless there's fragment data
    if (!data.types.includes(`application/${AhaEditor.clipboardFormatKey}`)) {
      return false;
    }

    if (!editor.selection) return false;

    // If we're not in a list, don't continue
    if (!getParentList(editor, editor.selection.anchor)) return false;

    const fragmentString = data.getData(
      `application/${AhaEditor.clipboardFormatKey}`
    );

    const ahaEditor = AhaEditor.getForEditor(editor);
    const decodedFragment = decodeFragment(fragmentString);
    const fragment = ahaEditor
      ? ahaEditor.transformPastedFragment(decodedFragment, data)
      : decodedFragment;

    const blockChildren = TableUtils.extractBlocksFromSingleCell(fragment);

    return spliceFragmentIntoList(editor, blockChildren);
  },
};

export default PasteFragmentIntoListPlugin;
